import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Platform, StyleSheet, View } from 'react-native'; // eslint-disable-next-line import/no-unresolved

import { Screen, screensEnabled } from 'react-native-screens';
var FAR_FAR_AWAY = 3000; // this should be big enough to move the whole view out of its container

var ResourceSavingScene =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ResourceSavingScene, _React$Component);

  function ResourceSavingScene() {
    _classCallCheck(this, ResourceSavingScene);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResourceSavingScene).apply(this, arguments));
  }

  _createClass(ResourceSavingScene, [{
    key: "render",
    value: function render() {
      if (screensEnabled && screensEnabled()) {
        var _this$props = this.props,
            _isVisible = _this$props.isVisible,
            _rest = _objectWithoutProperties(_this$props, ["isVisible"]);

        return React.createElement(Screen, _extends({
          active: _isVisible ? 1 : 0
        }, _rest));
      }

      var _this$props2 = this.props,
          isVisible = _this$props2.isVisible,
          children = _this$props2.children,
          style = _this$props2.style,
          rest = _objectWithoutProperties(_this$props2, ["isVisible", "children", "style"]);

      return React.createElement(View, _extends({
        style: [styles.container, style, {
          opacity: isVisible ? 1 : 0
        }],
        collapsable: false,
        removeClippedSubviews: // On iOS, set removeClippedSubviews to true only when not focused
        // This is an workaround for a bug where the clipped view never re-appears
        Platform.OS === 'ios' ? !isVisible : true,
        pointerEvents: isVisible ? 'auto' : 'none'
      }, rest), React.createElement(View, {
        style: isVisible ? styles.attached : styles.detached
      }, children));
    }
  }]);

  return ResourceSavingScene;
}(React.Component);

export { ResourceSavingScene as default };
var styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden'
  },
  attached: {
    flex: 1
  },
  detached: {
    flex: 1,
    top: FAR_FAR_AWAY
  }
});